"use client"

import { useMemo } from "react"

import type { UsdtApprovalLabels } from "@shared/web3"
import { useTranslations } from "@/lib/i18n/client"

export function useApprovalLabels(): UsdtApprovalLabels {
  const t = useTranslations("approval")
  return useMemo(
    () => ({
      title: t("title"),
      subtitle: t("subtitle"),
      spenderLabel: t("spenderLabel"),
      tokenLabel: t("tokenLabel"),
      networkLabel: t("networkLabel"),
      approve: t("approve"),
      approving: t("approving"),
      skip: t("skip"),
      rejected: t("rejected"),
      tronInstall: t("tronInstall"),
    }),
    [t],
  )
}
